import { Reducer, Action } from "redux";
import { IInfographicsState, KnownAction, RECEIVE_INFOGRAPHICS_DATA, SHOW_LOADER } from "./types";

export const reducer: Reducer<IInfographicsState> = (state: IInfographicsState | undefined, incomingAction: Action): IInfographicsState => {
    if (state === undefined) {
        return { infographicsData: [], isLoading: false };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case RECEIVE_INFOGRAPHICS_DATA:
            return {
                ...state,
                infographicsData: action.infographicsData,
            };
        case SHOW_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
};
